import { ProductsGroupCard } from "..";
import { Button } from "shared/ui/button";
import { useMobile } from "shared/lib/hooks";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import { useModal } from "shared/ui/modal";
import Injections from "../assets/Injections.jpg";
import Equipment from "../assets/Equipment.jpg";
import Сosmetics from "../assets/Сosmetics.jpg";
import styles from "./ProductsSection.module.scss";

export const ProductsSection = () => {
  const isMobile = useMobile("950px");

  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  return (
    <>
      <div className={styles.productsContainer}>
        <p className={styles.productsContainer__title}>Продукция</p>
        <div className={styles.productsWrapper}>
          <ProductsGroupCard
            productImg={Injections}
            productName="Препараты"
            onClick={openDisabledElementModal}
          />
          <ProductsGroupCard
            productImg={Equipment}
            productName="Косметологическое оборудование"
            onClick={openDisabledElementModal}
          />
          <ProductsGroupCard
            productImg={Сosmetics}
            productName="Профессиональная косметика"
            onClick={openDisabledElementModal}
          />
        </div>
        {isMobile ? (
          <div className={styles.productsContainer__buttonBlock}>
            <div className={styles.productsContainer__button}>
              <Button
                variant="disabled"
                size="large"
                onClick={openDisabledElementModal}
              >
                Перейти в каталог
              </Button>
            </div>
          </div>
        ) : null}
      </div>
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
